<template>
  <div class="content-wrap" v-if="!loading">
    <Progress
      class="progress-wrap"
      :percentage="percentage"
      :show-pivot="false"
    />
    <NoticeBar
      v-if="$store.getters.getIsPreview && $store.getters.getIsPreview === 1"
      background="#FFF6EF"
      color="#FA964E"
      text="提示：当前为预览页面，答案不被记录"
    />
    <!-- 自定义的背景 -->
    <div class="content-diy-bg"></div>
    <div
      v-if="!isReview && $store.getters?.getQuesInfo?.type !== 1"
      class="top-timer"
    >
      倒计时
      <Count-down
        @finish="handleCountDownFinished"
        class="timer"
        :time="
          quesSetting?.timePass
            ? quesSetting?.timePass * 60 * 1000
            : 60 * 60 * 1000
        "
      />
    </div>
    <div
      :class="[
        'main-content',
        {
          'hide-title-tip':
            $route.query.questionActiveKey === QUES_KEY_2023_4_12,
        },
      ]"
    >
      <h1
        v-if="$route.query.questionActiveKey === QUES_KEY_2023_4_12"
        class="ques-title"
      >
        <p v-for="item in quesInfo?.title.split(' ')">{{ item }}</p>
      </h1>
      <h1 v-else class="ques-title">
        {{ quesInfo?.title }}
      </h1>
      <div v-html="quesInfo?.content" class="ques-tips"></div>
      <Swipe
        class="slide-banner-wrapper"
        :autoplay="3000"
        indicator-color="white"
      >
        <Swipe-Item
          class="slide-banner-content"
          v-for="(item, index) in swiperList"
          :key="item + index + ''"
          @click="handleImgPreview(swiperList, index)"
        >
          <img :src="item" alt="" />
        </Swipe-Item>
      </Swipe>
      <div @click.capture="handleClickCaptrue">
        <div class="ques-content">
          <ul
            class="ques-item"
            v-for="(item, index) in showList"
            :key="item.questionKey"
            :class="{ 'logic-hide-item': !judgeIsShow(item) }"
            :id="item.questionKey"
          >
            <!-- 设置了逻辑后是否显示 -->
            <template v-if="!judgeIsShow(item, index)"></template>
            <!-- 单项填空题 -->
            <Info-Input
              v-else-if="
                item.questionType == 4 ||
                item.questionType == 11 ||
                item.questionType == 16 ||
                item.questionType == 21 ||
                item.questionType == 24 ||
                item.questionType == 25
              "
              :data="item"
              :quesIndex="index"
              :isReview="isReview"
              :currentChecked="reviewList.length > 0 ? reviewList?.[index] : ''"
              @inputChange="handleRadioSelect"
              @changeVerify="handleChangeVerify"
            />
            <!-- 多项填空题 -->
            <ManyInput
              v-else-if="item.questionType === 5"
              @inputChange="hanldeManyInput"
              :quesIndex="index"
              :info="item"
              :isReview="isReview"
            />
            <!-- 完型填空 -->
            <MulBlankInput
              v-else-if="item.questionType === 26"
              @inputChange="hanldeManyInput"
              :quesIndex="index"
              :data="item"
              :isReview="isReview"
            />
            <!-- 城市选择 -->
            <City-Select
              v-else-if="item.questionType == 9 || item.questionType == 10"
              :data="item"
              :isReview="isReview"
              :quesIndex="index"
              :value="reviewList.length > 0 ? reviewList?.[index] : ''"
              @selectCity="handleSelectCity"
            />
            <!-- 下拉框 -->
            <Drop-Down-Box
              v-else-if="item.questionType === 2"
              :data="item"
              :quesIndex="index"
              :isReview="isReview"
              @selectCity="handleSelectCity"
              :value="item.value"
            />
            <!-- 日期选择题 -->
            <DatePicker
              v-else-if="item.questionType === 28"
              :data="item"
              :quesIndex="index"
              :isReview="isReview"
              @dateSelect="handleRadioSelect"
              :value="item.value"
            />
            <!-- 上传题 -->
            <Upload
              v-else-if="item.questionType === 3"
              :quesIndex="index"
              :info="item"
              @uploadFinished="handleRadioSelect"
            />
            <!-- 云上传 -->
            <!-- <CloudUpload
            v-else-if="item.questionType === 3"
            :quesIndex="index"
            :info="item"
            @uploadFinished="handleRadioSelect"
          /> -->
            <!-- 级联题 -->
            <Cascader
              v-else-if="
                item.questionType === 20 ||
                item.questionType === 100 ||
                item.questionType === 101 ||
                item.questionType === 102 ||
                item.questionType === 103 ||
                item.questionType === 104
              "
              :quesIndex="index"
              :data="item"
              @cascaderChange="handleRadioSelect"
            />
            <!-- 多选 -->
            <Multi-Choice
              v-else-if="item.questionType === 18 || item.questionType === 1"
              @radioSelect="handleCheckBoxChange"
              :quesIndex="index"
              :data="item"
              :isReview="isReview"
              :currentChecked="reviewList.length > 0 ? reviewList?.[index] : []"
            />
            <!-- 单选择题 -->
            <Single-Choice
              v-else
              @radioSelect="handleRadioSelect"
              :quesIndex="index"
              :data="item"
              :isReview="isReview"
              :currentChecked="
                reviewList.length > 0 ? reviewList?.[index]?.[0] : ''
              "
            />
          </ul>
          <SubmitConfirm v-if="isShowAgreeSubmit" @checked="(checked) => { isAgreeSubmit = checked }" />
        </div>
          <div v-if="!isReview" class="btn-wrap">
            <Button
              :loading="submitFlag"
              loading-type="spinner"
              @click="
                () => {
                  handleFinshedClick()
                  handleBuryClick('完成')
                }
              "
              class="submit-btn"
              :class="{
                'special-submit-btn': $route.query.questionActiveKey === '2d4abe3fcec0479f9ced38eb05822616',
              }"
              >{{ isPayQues ? '报名缴费' : '完成'  }}</Button
            >
          </div>
      </div>
    </div>
    <!-- 填报前弹窗 -->
    <BeforeToast
      v-if="showBeforeToast"
      @confirm="handleBeforeToastConfirm"
      @close="showBeforeToast = false"
    />
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import qs from 'qs'
import SingleChoice from '@/components/choice/SingleChoice'
import MultiChoice from '@/components/choice/MultiChoice'
import InfoInput from '@/components/input/InfoInput'
import ManyInput from '@/components/input/ManyInput'
import MulBlankInput from '@/components/input/MulBlankInput'
import CitySelect from '@/components/citySelect/index'
import DropDownBox from '@/components/dropDownBox/index'
import Cascader from '@/components/cascader/index'
import Upload from '@/components/upload/index'
import DatePicker from '@/components/datePicker/index'
// import CloudUpload from '@/components/cloudUpload/index'
import BeforeToast from '@/components/beforeToast'
import {
  CountDown,
  Button,
  Loading,
  Swipe,
  SwipeItem,
  NoticeBar,
  Progress,
  Dialog,
  Toast,
} from 'vant'
import {
  ref,
  reactive,
  watchEffect,
  watch,
  onMounted,
  onUnmounted,
  toRaw,
  nextTick,
} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { createCaptcha } from 'xt-captcha'
import { getPessonQuesList, cacheQues, getCacheQues, getReview } from '@/api/index'
import { useImagePreview, useStartBtnClick } from '@/hooks/index.js'
import { getUserLossStatus } from '@/api/person'
import { useCommonQuesListEffect } from '@/effects/quesListEffect'
import { useCommonSubmitEffect } from '@/effects/submitEffect'
import { useCommonCountDownEffect } from '@/effects/countdownEffect'
import { computed } from '@vue/reactivity'
import { getQueryString } from '@/utils/tools'
import {
  QUES_KEY_2023_4_12,
  LOCAL_QUES_ANSWERS,
  LOCAL_QUES_ANSWERS_UUID,
} from '@/constants'
import SubmitConfirm from '@/components/choice/SubmitConfirm.vue'

export default {
  components: {
    SingleChoice,
    MultiChoice,
    InfoInput,
    MulBlankInput,
    CitySelect,
    DatePicker,
    ManyInput,
    DropDownBox,
    Cascader,
    CountDown,
    Swipe,
    SwipeItem,
    Upload,
    // CloudUpload,
    BeforeToast,
    Button,
    Loading,
    NoticeBar,
    Progress,
    SubmitConfirm
  },
  setup() {
    const route = useRoute()

    const { personList } = usePesonListEffect()

    const { list, isReview, quesInfo, quesSetting, reviewList, loading } =
      useListEffect()

    const { swiperList } = useSwiperEffect()

    // 提交事件
    const {
      handleFinshedClick,
      isSubmit,
      answers,
      submitFlag,
      isAgreeSubmit,
      isShowAgreeSubmit,
      handleChangeVerify,
    } = useSubmitEffect(reviewList)

    // 填报前弹窗
    const {
      showBeforeToast,
      isAgreeBeforeToast,
      handleBeforeToastConfirm,
    } = useBeforeToastEffect()

    // 选择
    const {
      handleRadioSelect,
      handleCheckBoxChange,
      handleSelectCity,
      hanldeManyInput,
      handleClickCaptrue,
    } = useChoiceEffect(answers, isReview, isAgreeBeforeToast, showBeforeToast)

    const { handleBackClick } = useBackEffect()

    // 倒计时结束
    const { handleCountDownFinished } = countdownEffect(
      answers,
      submitFlag,
      isSubmit,
      isAgreeSubmit,
      isShowAgreeSubmit,
    )

    const store = useStore()
    // 展示的list
    const showList = computed(() => {
      if (isReview) {
        console.log('store.getters', store.getters)
        return [...store.getters.getReviewList]
      }
      return [...personList.value, ...list.value]
    })

    // 进度条
    const percentage = computed(() => {
      const filledList = answers.filter((item) => {
        return item.answers.length > 0
      })

      // 有一个特殊点，假如是多项填空的时候

      return (filledList.length / showList.value.length) * 100 || 0
    })

    const { aduditStaut } = useAduditStatus()

    // 轮播点击事件
    const { handleImgPreview } = useImagePreview()

    const { judgeIsShow } = useLogicShowEffect(answers, showList)

    // 埋点点击
    const handleBuryClick = (name) => {}

    // 是否开启了支付填报
    const isPayQues = computed(() => {
      return quesInfo.isLogin === 1 && quesInfo?.payStatus === 2
    })

    return {
      submitFlag,
      isReview,
      quesInfo,
      quesSetting,
      reviewList,
      swiperList,
      loading,
      isPayQues,
      showList,
      showBeforeToast,
      handleBeforeToastConfirm,
      percentage,
      aduditStaut,
      handleChangeVerify,
      handleRadioSelect,
      handleCheckBoxChange,
      handleFinshedClick,
      handleClickCaptrue,
      hanldeManyInput,
      handleBackClick,
      handleCountDownFinished,
      handleSelectCity,
      handleBuryClick,
      handleImgPreview,
      judgeIsShow,
      QUES_KEY_2023_4_12,
      isAgreeSubmit,
      isShowAgreeSubmit
    }
  },
}

// 获取试题回顾列表
const useReviewListEffetc = async () => {
  const store = useStore()
  const answerGroupKey = getQueryString('answerGroupKey')
  const questionActiveKey = getQueryString('questionActiveKey')
  const type = getQueryString('type')
  const isReview = getQueryString('isReview')

  console.log('isReview', isReview)

  if (isReview) {
    const res = await getReview({
      questionActiveKey,
      answerGroupKey: answerGroupKey,
      type: type,
      token: store.getters.getToken,
    })

    if (res.ok) {
      store.commit('setReviewList', {
        data: res.data,
      })
    }
  }
}

// 填报前弹窗
const useBeforeToastEffect = () => {
  const store = useStore()
  const route = useRoute()

  const showBeforeToast = ref(false)
  const isAgreeBeforeToast = ref(route.query.isAgreeBeforeToast ? true : false)

  const isReview = Boolean(route.query.isReview ? route.query.isReview : 0)

  const type = route.query.type

  onMounted(() => {
    if (!isReview && type !== 'mock' && store.getters?.isShowBefore && !isAgreeBeforeToast.value) {
      showBeforeToast.value = true
    }

    if (type === 'mock') {
      isAgreeBeforeToast.value = true
    }
  })

  const handleBeforeToastConfirm = () => {
    isAgreeBeforeToast.value = true
    showBeforeToast.value = false
  }

  return {
    showBeforeToast,
    isAgreeBeforeToast,
    handleBeforeToastConfirm,
  }
}

// 初始化list
const useListEffect = () => {
  const store = useStore()
  const route = useRoute()
  const isReview = Boolean(route.query.isReview ? route.query.isReview : 0)
  const answerGroupKey = getQueryString('answerGroupKey')
  const questionActiveKey = getQueryString('questionActiveKey')
  const type = getQueryString('type')
  const list = ref([])
  const reviewList = ref([])

  // 获取数据
  const { getQuesData, loading } = useCommonQuesListEffect()

  if (isReview) {
    onMounted(async () => {
      const res = await getReview({
        questionActiveKey,
        answerGroupKey: answerGroupKey,
        type: type,
        token: store.getters.getToken,
      })

      if (res.ok) {
        store.commit('setReviewList', {
          data: res.data,
        })

        list.value = res.data

        reviewList.value = reviewEffect(list)

        loading.value = false
      }
    })


  } else {
    getQuesData(list)
    list.value = [...store.getters.getQuesList]
  }
  const quesInfo = store.getters.getQuesInfo
  const quesSetting = store.getters.getQuesSetting

  return {
    list,
    loading,
    reviewList,
    isReview,
    quesInfo,
    quesSetting,
  }
}

// 获取审核状态
const useAduditStatus = () => {
  const answerGroupKey = getQueryString('answerGroupKey')
  const result = reactive({
    text: '',
    reason: '',
  })
  const fetchData = async () => {
    const res = await getUserLossStatus({
      answerGroupKey,
    })
    // 1 已提交 2已审核
    if (res.ok) {
      const data = res.data
      if (data.status == 1) {
        result.text = '待审核'
      }
      if (data.status == 2) {
        result.text = '已通过'
      }
      if (data.status == 3) {
        result.text = '已驳回'
        result.reason = data.reason
      }
      if (data.status == 0) {
        result.text = '已撤销'
      }
    }
  }

  if (answerGroupKey) {
    fetchData()
  }

  return {
    aduditStaut: result,
  }
}

// 获取个人题
const usePesonListEffect = () => {
  const personList = ref([])
  const store = useStore()
  const route = useRoute()

  let type = 1
  if (store.getters.getQuesInfo?.type !== 1) {
    type = 2
  }
  const getData = async () => {
    const res = await getPessonQuesList({
      questionActiveKey: route.query.questionActiveKey,
      type,
    })
    personList.value = res?.data
  }

  // 报名的时候 在里边展示个人题型
  if (store.getters.getQuesInfo?.type === 1) {
    getData()
  }

  return {
    personList,
  }
}

// 逻辑题的显示判断
const useLogicShowEffect = (answers) => {
  // 找到绑定的题的对应的答案
  const findAnswer = (data1, data2) => {
    let map1 = new Map()
    for (let item of data1) {
      map1.set(item.questionKey, item.optionKey)
    }

    // 创建一个数组，用于保存找到的对象
    let results = []

    // 在第二段数据中查找
    for (let item of data2) {
      let questionKey = item.questionKey
      if (map1.has(questionKey)) {
        let optionKey = map1.get(questionKey)
        for (let answer of item.answers) {
          if (answer.optionKey === optionKey) {
            // 找到了对应的对象，添加到结果数组中
            results.push(answer)
          }
        }
      }
    }

    // 返回结果数组
    return results
  }

  const judgeIsShow = (ques, index) => {
    if (ques.bindKey) {
      const bindList = JSON.parse(ques.bindKey)
      const result = findAnswer(bindList, answers)

      // 假如答案里边选了绑定逻辑的，就可以展示
      const hideList = document.querySelectorAll('.logic-hide-item')

      nextTick(() => {
        const ele = document.getElementById(`${result?.[0]?.questionKey}`)
        if (ele?.classList.contains('logic-hide-item')) {
          const index = answers.findIndex(
            (item) => item.questionKey === result?.[0]?.questionKey
          )

          if (index !== -1) {
            answers.splice(index, 1)
          }
        }
      })
      return result.length > 0
    }

    return !ques.bindKey
  }

  return {
    judgeIsShow,
  }
}

// 回顾list 设置正确值
const reviewEffect = (list) => {
  const reviewRightList = []
  // 回顾的时候 暂时因为后台没有处理好个人信息题的顺序问题，所以这里把个人信息题都过滤掉了
  const personFilter = []
  list.value.forEach((item) => {
    const arr = []
    // 填空题的返显值
    if (
      item.questionType === 9 ||
      item.questionType === 10 ||
      item.questionType === 11 ||
      item.questionType === 16 ||
      item.questionType === 20 ||
      item.questionType === 21
    ) {
      reviewRightList.push(item.value)
    } else {
      if (item.questionType !== 12 && item.questionType !== 13) {
        personFilter.push(item)
        item.optionVoList.forEach((option) => {
          if (option.isSelect === 1) {
            arr.push(option.optionKey)
          }
        })
        reviewRightList.push(arr)
      }
    }
  })

  list.value = personFilter

  return reviewRightList
}

// 选择相关逻辑
const useChoiceEffect = (
  answers,
  isReview,
  isAgreeBeforeToast,
  showBeforeToast
) => {
  const store = useStore()

  // 单多选择题/输入框选择变动处理
  const handleRadioSelect = (data) => {
    // 防止输入题的值为空的时候被过滤掉
    if (!data.value && !data.type) {
      return null
    }

    // 找到更改的部分，假如是新的题目第一次选直接推进去
    const res = answers.filter(
      (item) => item.questionKey === data.questionKey
    )[0]
    if (res) {
      // 处理input内容
      if (data.type === 'input') {
        res.answers[0].answerContent = data.value
      } else {
        res.answers[0].optionKey = data.value.join(',')
        res.answers[0].remarkContent = data.remarkContent
      }
    } else {
      if (data.type === 'input') {
        answers.push({
          questionKey: data.questionKey,
          questionType: data.questionType,
          answers: [
            {
              questionKey: data.questionKey,
              optionKey: data.optionKey,
              answerContent: data.value,
            },
          ],
        })
      } else {
        answers.push({
          questionKey: data.questionKey,
          questionType: data.questionType,
          answers: [
            {
              questionKey: data.questionKey,
              optionKey: data.value.join(','),
              answerContent: data.answerContent,
              remarkContent: data.remarkContent,
            },
          ],
        })
      }
    }
    // localStorage.setItem('localAnswers', JSON.stringify(answers))
  }

  // 多选数据变动
  const handleCheckBoxChange = (data) => {
    console.log('data', data)
    const index = answers.findIndex(
      (item) => item.questionKey === data.questionKey
    )

    if (index !== -1) {
      answers[index] = data
    } else {
      answers.push(data)
    }
  }

  // 多项填空题
  const hanldeManyInput = (data) => {
    const index = answers.findIndex((v, i) => {
      return v.questionKey === data.questionKey
    })
    if (index === -1) {
      answers.push(data)
    } else {
      answers[index] = data
    }
  }

  // 城市选择
  const handleSelectCity = (data) => {
    const index = answers.findIndex(
      (item) => item.questionKey === data.questionKey
    )

    if (index === -1) {
      answers.push(data)
    } else {
      answers[index] = data
    }
    localStorage.setItem('localAnswers', JSON.stringify(answers))
  }

  // 捕获点击事件
  const handleClickCaptrue = (e) => {
    if (isReview) {
      e.stopPropagation()

      return
    }

    // 开启填报前弹窗 和 未同意之前不让点击
    if (store.getters?.isShowBefore && !isAgreeBeforeToast.value) {
      showBeforeToast.value = true
      e.stopPropagation()

      return
    }
  }

  return {
    handleRadioSelect,
    handleCheckBoxChange,
    hanldeManyInput,
    handleSelectCity,
    handleClickCaptrue,
  }
}

// 提交相关逻辑
const useSubmitEffect = (reviewList) => {
  const answers = reactive([])
  const store = useStore()
  const route = useRoute()
  const uuid = localStorage.getItem(LOCAL_QUES_ANSWERS_UUID) || uuidv4()
  // 验证码
  const captcha = ref(null)

  const isShowCaptcha = computed(() => {
    return store.getters.getQuesInfo?.captchaStatus === 2
  })

  onMounted(() => {
    if (isShowCaptcha.value) {
      nextTick(() => {
        captcha.value = createCaptcha({
          // 三种模式 默认slide滑动拼图
          mode: 'slide',
          // 验证回调
          onVerify({ error, result }) {
            // 验证失败 不需要其他额外处理，内部做了失败刷新处理
            if (error) {
            }
            // 验证成功
            if (result) {
              // result.data 返回为验证成功后的凭证
              handleFinshedClick(false, result.data)
            }
          },
          // 关闭弹窗的回调
          onClose(close) {
            // close 为字符串 'close'
          },
        })
      })
    }
  })

  localStorage.setItem(LOCAL_QUES_ANSWERS_UUID, uuid)

  try {
    const localAnswers = JSON.parse(localStorage.getItem(LOCAL_QUES_ANSWERS))

    // 遍历一下localAnswers，只有当localAnswers里边的题目在当前题目里边才推进去
    if (localAnswers && store.getters.getQuesInfo?.type !== 3) {
      localAnswers.forEach((item) => {
        const index = reviewList.findIndex(
          (v) => v.questionKey === item.questionKey
        )
        if (index !== -1) {
          answers.push(item)
        }
      })
    }

    // if (localAnswers && store.getters.getQuesInfo?.type !== 3) {
    //   answers.push(...JSON.parse(localStorage.getItem(LOCAL_QUES_ANSWERS)))
    // }
  } catch (error) {}

  // 每次答案变动都存储到本地
  watch(
    answers,
    (n) => {
      // 除了答题不缓存
      if (store.getters.getQuesInfo.type !== 3) {
        localStorage.setItem(LOCAL_QUES_ANSWERS, JSON.stringify(answers))
      }
    },
    { deep: true }
  )

  // 缓存接口
  const saveAnswers = async () => {
    if (
      answers.length === 0 ||
      !store.state.token ||
      store.getters.getQuesInfo.type !== 3
    ) {
      return
    }
    cacheQues(
      qs.stringify({
        uuid,
        token: store.state.token,
        questionActiveKey: route.query.questionActiveKey,
        content: JSON.stringify(answers),
      })
    )
  }

  const saveAnswersInterval = ref(null)

  onMounted(() => {
    // 隔10秒自动保存一次
    // saveAnswersInterval.value = setInterval(() => {
    //   saveAnswers()
    // }, 1000 * 10)
  })

  onUnmounted(() => {
    clearInterval(saveAnswersInterval.value)
    captcha.value?.destroy()
  })

  // 用来判断是否提交了 避免倒计时结束二次提交
  const isSubmit = ref(false)

  // 校验与否
  const isVerify = ref(false)

  const handleChangeVerify = (value) => {
    isVerify.value = value
  }

  // 是否是回顾
  const isReview = !!getQueryString('isReview')

  // 是否显示同意提交
  const isShowAgreeSubmit = computed(() => {
    return !isReview && store.getters.getQuesInfo?.readStatus === 2
  })
  // 是否同意提交
  const isAgreeSubmit = ref(false)

  const { handleSubmitClick, submitFlag } = useCommonSubmitEffect()
  const handleFinshedClick = (isRefresh, captrueRes) => {
    if (isVerify.value) {
      return
    }

    if (isShowAgreeSubmit.value && !isAgreeSubmit.value) {
      Toast('请先同意提交')

      return
    }

    const questionActiveKey = route.query.questionActiveKey
    if (isShowCaptcha.value && captrueRes === undefined) {
      captcha.value?.open()
      return
    }
    captcha.value?.close()
    captcha.value?.refresh()
    // captcha.value?.destroy()

    // 判断多选题是否符合要求
    const hasInvalidAnswers = answers.some(item => {
      return item.questionType == 1 &&
          ((item.minSelectNum && item.answers.length < item.minSelectNum) ||
              (item.maxSelectNum && item.answers.length > item.maxSelectNum))
    })
    if (hasInvalidAnswers) {
      Dialog({ message: '您有题目未按要求完成' })
      return;
    }

    handleSubmitClick(answers, isSubmit, isRefresh)
  }

  return {
    answers,
    isSubmit,
    submitFlag,
    isAgreeSubmit,
    isShowAgreeSubmit,
    handleFinshedClick,
    handleChangeVerify,
  }
}

// 返回相关逻辑
const useBackEffect = () => {
  // 返回
  const router = useRouter()
  const handleBackClick = () => {
    window.history.length > 1 ? router.go(-1) : router.push('/')
  }

  return {
    handleBackClick,
  }
}

// 倒计时结束相关逻辑
const countdownEffect = (answers, submitFlag, isSubmit, isAgreeSubmit, isShowAgreeSubmit,) => {
  const { handleCountDown } = useCommonCountDownEffect()
  const handleCountDownFinished = () => {
    // 假如倒计时结束的时候 用户已经点了提交 那就不走这里了
    if (isSubmit.value) {
      return
    }


    if (isShowAgreeSubmit.value && !isAgreeSubmit.value) {
      Toast('请先同意提交')

      return
    }

    // 防止倒计时结束二次提交
    submitFlag.value = true
    handleCountDown(answers, submitFlag)
  }

  return {
    handleCountDownFinished,
  }
}

// 设置轮播
const useSwiperEffect = () => {
  const store = useStore()
  const swiperList = ref([])

  watchEffect(() => {
    swiperList.value = []
    swiperList.value = store.getters.getSwiperList
  })

  return {
    swiperList,
  }
}
</script>

<style lang="scss" scoped>
.content-wrap {
  max-width: 100vw;
  overflow-x: hidden;
}
.wrap {
  // height: 100vh;
  // overflow: scroll-y;
}

.progress-wrap {
  position: fixed;
  top: 0;
  z-index: 101;
}
.top-timer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: #fff6ef;
  font-size: 28px;
  font-weight: 500;
  color: #fa964e;
  z-index: 100;

  .timer {
    display: inline-block;
    font-size: 28px;
    font-weight: 500;
    color: #fa964e;
  }
}

.audit-wrap {
  position: fixed;
  right: 0.4rem;
  top: 0.1rem;

  .reason-wrap {
    font-size: 0.4rem;
  }

  .audit-status {
    display: inline-block;
    font-size: 0.6rem;
  }

  .namal {
    color: #3795ff;
  }

  .success {
    color: green;
  }

  .error {
    color: red;
  }

  .revoke {
    color: azure;
  }
}

.ques-title {
  margin: 0 10px;
  padding-top: 90px;
  margin-bottom: 20px;
  font-size: 38px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #3795ff;
  line-height: 48px;
  text-align: center;
}
.mg-t-50 {
  margin-top: 50px;
}

::v-deep .ques-tips {
  margin: 0 34px;
  margin-top: 37px;
  line-height: 1.5;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  text-align: left;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 25px 0;
  }
  p {
    margin: 20px 0;
    line-height: 1.5;
    font-size: 32px;
  }

  strong {
    font-weight: bold;
  }

  &::after {
    margin-top: 47px;
    display: block;
    content: '';
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #c5c5c5;
  }
}
.slide-banner-wrapper {
  // margin-top: 20px;
  ::v-deep .van-tabs__wrap {
    touch-action: manipulation;
  }
  img {
    width: 100%;
    height: 440px;
    object-fit: cover;
  }
}

.btn-wrap {
  display: flex;
  justify-content: space-between;
  padding: 0 40px;
  gap: 0 10px;

  .submit-btn {

    flex: 1;
    // width: 300px;
  }
}

.submit-btn {
  margin: 136px auto;
  display: block;
  width: 700px;
  height: 88px;
  background: linear-gradient(-90deg, #388fff 0%, #2faeff 100%);
  border-radius: 44px;
  border: 1px solid #2faeff;
  font-size: 34px;
  font-weight: 500;
  color: #ffffff;
}

.special-submit-btn {
  background: linear-gradient(
      -90deg
      , rgba(240,111,23,1) 0%, rgba(244,71,34,1) 100%) !important;
  border: none;
}
</style>
